/*!
 * Copyright 2019 Fondazione Bruno Kessler
 * Licensed under the EUPL, Version 1.1 or - as soon they will be approved by the European
 * Commission - subsequent versions of the EUPL (the "Licence"); You may not use this work
 * except in compliance with the Licence.
 *
 * You may obtain a copy of the Licence at:
 * http://ec.europa.eu/idabc/eupl.html
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the Licence is distributed on an "AS IS" basis, WITHOUT WARRANTIES OR CONDITIONS OF
 * ANY KIND, either express or implied. See the Licence for the specific language
 * governing permissions and limitations under the Licence.
 */

import {ChangeDetectionStrategy, Component, Input, OnInit, ViewChild} from "@angular/core";
import {UntypedFormBuilder, UntypedFormControl, Validators} from "@angular/forms";
import {ModalController} from "@ionic/angular";
import {ActivationCodeType} from "@trec/api/salute-helper";
import {AppActivationCodeViewComponent} from "../app-activation-code-view/app-activation-code-view.component";

export interface AppActivationCodeDialogData {
  patientFiscalCode?: string;
  firstTime?: boolean;
  email?: string;
  phone?: string;
}

@Component({
  selector: "c3-app-activation-code-dialog",
  templateUrl: "./app-activation-code-dialog.component.html",
  styleUrls: ["./app-activation-code-dialog.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class AppActivationCodeDialogComponent implements OnInit {
  @Input()
  data: AppActivationCodeDialogData;

  @ViewChild(AppActivationCodeViewComponent)
  appCodeViewComp: AppActivationCodeViewComponent;

  activationCode: ActivationCodeType | null;

  showGenerateButton = true;

  get showFiscalCodeField(): boolean {
    return !this.data.patientFiscalCode;
  }

  get showEmailField(): boolean {

    if (this.activationCode && (this.activationCode == ActivationCodeType.email || this.activationCode == ActivationCodeType.emailsms)) {
      return true;
    }
    return false;
  }

  get showPhoneField(): boolean {
    if (this.activationCode && (this.activationCode == ActivationCodeType.emailsms || this.activationCode == ActivationCodeType.visiblesms)) {
      return true;
    }
    return false;
  }

  hideGenerateButton(activationCode): void {
    if (activationCode === undefined || activationCode === null) {
      this.showGenerateButton = true;
    }
  }

  readonly fiscalCodeControl: UntypedFormControl;
  readonly emailControl: UntypedFormControl;
  readonly telefonoControl: UntypedFormControl;

  constructor(private fb: UntypedFormBuilder, private modalCtrl: ModalController) {
    this.fiscalCodeControl = this.fb.control(null, [
      Validators.required,
      Validators.minLength(16),
      Validators.maxLength(16),
    ]);
    this.emailControl = this.fb.control(null, [
      Validators.required,
      Validators.email
    ]);
    this.telefonoControl = this.fb.control(null, [
      Validators.required,
      Validators.pattern("^[0-9]*$"),
      Validators.minLength(10),
      Validators.maxLength(10)
    ]);

    let configuratoreActivationCode = localStorage.getItem("configuratoreActivationCode");
    if (configuratoreActivationCode) {
      this.activationCode = JSON.parse(configuratoreActivationCode);
    }
  }

  ngOnInit() {

    if (this.data.patientFiscalCode) {
      this.fiscalCodeControl.patchValue(this.data.patientFiscalCode);
    }
    if (this.data.email && this.showEmailField) {
      this.emailControl.patchValue(this.data.email);
    }
    if (this.data.phone && this.showPhoneField) {
      this.telefonoControl.patchValue(this.data.phone);
    }
  }

  onGenerateCode() {
    if (this.fiscalCodeControl.valid) {
      this.showGenerateButton = false;
      this.appCodeViewComp.updateAppActivationCode(this.fiscalCodeControl.value, this.emailControl.value, this.telefonoControl.value);
    }
  }

  onClose() {
    this.modalCtrl.dismiss();
  }
}
